import { RawUserData, NormalizedUserData, FileUpload } from "../profile.types";

/**
 * Converts raw API user data (snake_case) to normalized form data (camelCase)
 */
export function normalizeUserData(user: RawUserData): NormalizedUserData {
  const {
    first_name,
    last_name,
    photo,
    photo_alt_text,
    resume,
    is_email_notifications_enabled,
    is_text_notifications_enabled,
    phone_number,
    ...rest
  } = user;

  const normalizedPhoto: FileUpload | undefined = photo
    ? {
        file: photo,
        name: "",
        size: 0,
        type: "",
        original: null,
        altText: photo_alt_text || "",
      }
    : undefined;

  const normalizedCv: FileUpload | undefined = resume
    ? {
        file: resume,
        name: "",
        size: 0,
        type: "",
        original: null,
      }
    : undefined;

  return {
    ...rest,
    firstName: first_name,
    lastName: last_name,
    isEmailNotificationsEnabled: is_email_notifications_enabled,
    isTextNotificationsEnabled: is_text_notifications_enabled,
    phoneNumber: phone_number,
    photo: normalizedPhoto,
    cv: normalizedCv,
  };
}

export default normalizeUserData;

